import {Link as ChakraLink, LinkProps} from '@chakra-ui/react'
//import {Link as DomRouterLink} from 'react-router-dom'
export const Link = (props: LinkProps & {to?: string}) => {
  return <ChakraLink {...props}></ChakraLink>
}
export default Link
